// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".login-page[data-v-16d8eba4] {\n  background: #f6fafb;\n  padding: 100px;\n  height: 100%;\n}\n.login-page .p-card[data-v-16d8eba4] {\n  max-width: 480px;\n  margin: 0 auto;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
